import { reactive } from 'vue';
type ScrollData = {
  isScrollBarVisible: boolean;
  isScrollBottom: boolean;
  scrollTimer: ReturnType<typeof setTimeout> | null;
};

function useScrollbar() {
  const scrollData = reactive<ScrollData>({
    isScrollBarVisible: false,
    isScrollBottom: false,
    scrollTimer: null,
  });
  function onScroll(ref: { value: HTMLDivElement | null }, offset = 1) {
    scrollData.isScrollBarVisible = true;
    if (scrollData.scrollTimer) {
      clearTimeout(scrollData.scrollTimer);
    }
    scrollData.scrollTimer = setTimeout(() => {
      scrollData.isScrollBarVisible = false;
    }, 250);
    if (ref.value) {
      const { scrollHeight, scrollTop, clientHeight, offsetTop } = ref.value;
      scrollData.isScrollBottom = scrollHeight <= (scrollTop || offsetTop) + clientHeight + offset;
    }

  }
  return { scrollData, onScroll }
}

export default useScrollbar
